import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'flex-end',
  },
  containerFilter: {
    height: 700,
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,

    paddingVertical: 15,
  },
  spaceHorizontal: {
    flex: 1,
    paddingHorizontal: 15,
  },
  iconX: {
    alignSelf: 'flex-end',
  },
  filterText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
    marginBottom: 10,
    alignSelf: 'center',
  },
  containerDrop: {
    marginTop: 30,
  },
  containerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 45,
    marginTop: 50,
  },
  label: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Regular',
    lineHeight: 19,
    color: 'black',
    marginBottom: 10,
    textAlign:'center',
  },
  containerButtons:{
    marginTop: 30,
    marginBottom: 120,
  },
  containerInput: {
    marginTop: 20,
  },
  requestContainer: {
    marginTop: 20,
    padding: 15,
    backgroundColor: '#f9f9f9',
    borderRadius: 10,
    color: 'black',
  },
  requestItemContainer: {
    color: 'black',
    gap: 10,


  },
  requestStatus: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Regular',
    lineHeight: 19,
    color: 'black',
  },
  requestText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  requestedDocument: {
    marginLeft: 20,
    fontSize: 14,
    lineHeight: 17,
    color: 'black',
    marginTop: 5,
  },
  containerButtonRequest: {
    width: '100%',
    marginTop: 20,
  }
});
